import { render, staticRenderFns } from "./FallbackVersao.vue?vue&type=template&id=e2c2a19c&scoped=true"
import script from "./FallbackVersao.vue?vue&type=script&lang=js"
export * from "./FallbackVersao.vue?vue&type=script&lang=js"
import style0 from "./FallbackVersao.vue?vue&type=style&index=0&id=e2c2a19c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2c2a19c",
  null
  
)

export default component.exports